import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledLabel,
  StyledBoxInput,
  LabelBlock,
  StyledCheckbox,
  StyledWrapperRow,
  StyledWrapperCell
} from './style';

import {
  StyledDropdownInputMonths,
  StyledDropdownInputYears,
  RangeDates,
  ItemRangeDates
} from './styleEducation';

import Input from '../../../core/Input';
import { EXPERIENCE } from '../../../../constants/literals/modals';

const ExperienceCurrentItem = ({
  companyName,
  checkedCurrentWork,
  listMonths,
  listYears,
  onChangeCheckbox,
  onChangeInputCompany,
  onChangeInputDescription,
  onChangeInputPosition,
  onSelectFromMonth,
  onSelectFromYear,
  onSelectUntilMonth,
  onSelectUntilYear,
  selectedFromMonth,
  selectedFromYear,
  selectedUntilMonth,
  selectedUntilYear,
  summary,
  title
}) => (
  <div>
    <StyledWrapperRow>
      <StyledWrapperCell>
        <StyledBoxInput>
          <StyledLabel>{EXPERIENCE.COMPANY_NAME} (*)</StyledLabel>
          <Input onChange={onChangeInputCompany} value={companyName} />
        </StyledBoxInput>
      </StyledWrapperCell>
      <StyledWrapperCell>
        <StyledBoxInput>
          <StyledLabel>{EXPERIENCE.POSITION} (*)</StyledLabel>
          <Input onChange={onChangeInputPosition} value={title} />
        </StyledBoxInput>
      </StyledWrapperCell>
    </StyledWrapperRow>

    <StyledBoxInput>
      <StyledLabel>{EXPERIENCE.DESCRIPTION}</StyledLabel>
      <Input
        multiline
        rows={4}
        onChange={onChangeInputDescription}
        value={summary}
      />
    </StyledBoxInput>
    <RangeDates>
      <ItemRangeDates>
        <LabelBlock id="fromRange">{EXPERIENCE.FROM} (*)</LabelBlock>
        <StyledDropdownInputMonths
          list={listMonths}
          selected={selectedFromMonth}
          ariaLabelledby="fromRange"
          onSelect={onSelectFromMonth}
          label={selectedFromMonth}
        />
        <StyledDropdownInputYears
          list={listYears}
          selected={selectedFromYear}
          ariaLabelledby="fromRange"
          onSelect={onSelectFromYear}
          label={selectedFromYear}
        />
      </ItemRangeDates>
      <ItemRangeDates>
        <LabelBlock disabled={checkedCurrentWork} id="untilRange">
          {EXPERIENCE.UNTIL} (*)
        </LabelBlock>
        <StyledDropdownInputMonths
          disabled={checkedCurrentWork}
          list={listMonths}
          selected={selectedUntilMonth}
          onSelect={onSelectUntilMonth}
          ariaLabelledby="untilRange"
          label={selectedUntilMonth}
        />
        <StyledDropdownInputYears
          disabled={checkedCurrentWork}
          list={listYears}
          selected={selectedUntilYear}
          onSelect={onSelectUntilYear}
          ariaLabelledby="untilRange"
          label={selectedUntilYear}
        />
      </ItemRangeDates>
    </RangeDates>
    <StyledCheckbox
      checked={checkedCurrentWork}
      onChange={onChangeCheckbox}
      label={EXPERIENCE.CURRENT_WORKER}
    />
  </div>
);

ExperienceCurrentItem.propTypes = {
  companyName: PropTypes.string,
  checkedCurrentWork: PropTypes.bool,
  listMonths: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ),
  listYears: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ),
  onChangeCheckbox: PropTypes.func,
  onChangeInputCompany: PropTypes.func,
  onChangeInputDescription: PropTypes.func,
  onChangeInputPosition: PropTypes.func,
  onSelectFromMonth: PropTypes.func,
  onSelectFromYear: PropTypes.func,
  onSelectUntilMonth: PropTypes.func,
  onSelectUntilYear: PropTypes.func,
  selectedFromMonth: PropTypes.string,
  selectedFromYear: PropTypes.string,
  selectedUntilMonth: PropTypes.string,
  selectedUntilYear: PropTypes.string,
  summary: PropTypes.string,
  title: PropTypes.string
};

ExperienceCurrentItem.defaultProps = {
  companyName: '',
  summary: '',
  title: '',
  selectedFromMonth: 'Mes',
  selectedFromYear: 'Año',
  selectedUntilMonth: 'Mes',
  selectedUntilYear: 'Año'
};

export default ExperienceCurrentItem;
